import Lista from './Lista';
import ListaItem from './Lista-item';

export {
    Lista,
    ListaItem
}


// WEBPACK FOOTER //
// ./src/components/lista/index.js